<template>
  <div
    class="antiplagiat_ant"
    :class="{ [curTheme]: true }" v-if="fullText || btnVisible || message">

    <div class="ant_title">Проверка на заимствования сервисом Антиплагиат</div>
    <router-link
      class="help-link"
      :to="{ path: '/help/9'}"
      target="_blank">
      Подробнее о проверке на Антиплагиат в разделе Помощь
    </router-link>
    <div class="ant_btn-row" v-if="btnVisible">
      <button
        @click="antiplagiatInit"
        class="normal-button">
        Отправить объект на проверку
      </button>
    </div>

    <div class="ant_msg" v-if="message">{{ message }}</div>

    <button
      class="lite-button ant_more-btn"
      @click="moreWinOn = true">
      Подробный отчет</button>

    <div
      v-if="fullText && fullText.length > 0"
      v-for="(rep, repI) in fullText"
      class="ant_item"
      :key="`rep-${repI}`">
      <div class="ant_review-title">{{ rep.Title }}</div>
      <div
        v-if="rep.Indicators"
        v-for="(ind, indI) in rep.Indicators"
        class="ant_item-row"
        :key="`rep-${repI}-ind-${indI}`">
        <div
          v-if="ind.Type === 'string'">
          <span class="ant_item-title">{{ ind.Title }}:</span>
          <span v-html="ind.Value" class="ant_item-value"/>
        </div>
      </div>
    </div>

    <el-dialog
      title="Проверка на заимствования сервисом Антиплагиат"
      class="ant_more-win_mwn"
      :visible.sync="moreWinOn">

      <div
        v-if="fullText && fullText.length > 0"
        v-for="(rep, repI) in fullText"
        class="ant_item"
        :key="`rep-${repI}`">
        <div class="ant_review-title">{{ rep.Title }}</div>
        <div
          v-if="rep.Indicators"
          v-for="(ind, indI) in rep.Indicators"
          class="ant_item-row"
          :key="`rep-${repI}-ind-${indI}`">
          <div
            v-if="ind.Type === 'string'">
            <span class="ant_item-title">{{ ind.Title }}:</span>
            <span v-html="ind.Value" class="ant_item-value"/>
          </div>
          <div v-else-if="ind.Type === 'table' && ind.Value.length > 1">
            <div class="ant_item-title">{{ ind.Title }}:</div>
            <table>
              <tr
                v-for="(vals, valsI) in ind.Value"
                :key="`rep-${repI}-ind-${indI}-vals-${valsI}`">
                <td
                  v-for="(val, valI) in vals"
                  v-html="val"
                  :key="`rep-${repI}-ind-${indI}-vals-${valsI}-val-${valI}`"/>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <button class="dialog-close-btn" @click="moreWinOn = false">
          Закрыть</button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';

export default {

  props: {
    objectId: '',
  },

  data() {
    return {
      review: null,
      btnVisible: false,
      message: '',
      moreWinOn: false,
    };
  },

  created() {
    this.fetchData();
  },

  computed: {

    fullText() {
      let fullText = null;
      if (this.review
        && this.review.Transient
        && this.review.Transient.FullText
        && this.review.Transient.FullText.length > 0
      ) {
        fullText = this.review.Transient.FullText;
      }
      return fullText;
    },

  },

  methods: {

    fetchData() {
      if (this.objectId) {
        axios.get(`reviews/object/${this.objectId}`).then((r) => {
          if (r.data.length) {
            for (let i = 0; i < r.data.length; i += 1) {
              if (r.data[i].Type === 'antiplagiat') {
                this.review = r.data[i];
                break;
              }
            }
          }
        }).catch(() => this.log('Ошибка при загрузке данных.'));

        const userId = this.$store.getters['user/getUserId'];
        if (userId) {
          axios.get(`objects/${this.objectId}/maycheck/antiplagiat`).then(() => {
            this.btnVisible = true;
          }).catch((err) => {
            if (err.response.status === 400) {
              this.message = err.response.data[0];
            }
          });
        }
      }
    },

    antiplagiatInit() {
      const userId = this.$store.getters['user/getUserId'];
      if (!userId) return;
      this.$confirm('Отправить ЦОАП на проверку в систему Антиплагиат?', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
      }).then(() => {
        axios.post(`objects/${this.objectId}/check/antiplagiat`).then(() => {
          this.btnVisible = false;
          this.$message.closeAll();
          this.$message({
            message: 'Объект поставлен в очередь на проверку. Анализ может занять какое-то время, ' +
              'можете проверить результаты через 5-10 минут, повторно посетив данную страницу.',
            showClose: true,
            duration: 6000,
          });
        }).catch((err) => {
          this.$message.closeAll();
          this.$message(err.response.data);
        });
      }).catch(() => this.$notify.info('Проверка отменена.'));
    },

  },
};
</script>

<style lang="scss">
@import "../styles/common/main";

.antiplagiat_ant {
  background: #1a1a1a;
  padding: 15px 25px !important;
  .ant_title {
    text-align: center;
    font-size: 18px;
    line-height: 21px;
    padding: 3px 10px 5px;
  }
  .ant_msg {
    padding: 10px 10px 10px 14px;
    margin-top: 9px;
    font-size: 14px;
    border: 1px solid rgba(240, 60, 90, .05);
    background: rgba(240, 60, 90, .1);
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: -1px;
      left: -1px;
      bottom: -1px;
      width: 3px;
      background: $color-2;
    }
  }
  .ant_btn-row {
    text-align: center;
    margin: 8px 0;
    .normal-button {
      padding: 8px 0 4px;
      display: block;
      width: 100%;
    }
  }
  .ant_no-reviews {
    padding-bottom: 20px;
  }
  .ant_review-title {
    margin-top: 3px;
  }
  .ant_item {
    margin: 15px 0 0;
  }
  .ant_item-row {
    .ant_item-title {
      color: #999;
    }
    .ant_item-value {
      a {
        font-size: 15px;
        color: lighten($color-2, 10%);
        border-bottom: 1px dotted lighten($color-2, 10%);
        cursor: pointer;
        @include transition;
        line-height: 13px;
        display: inline-block;
        &:hover {
          color: $color-1;
          border-bottom: 1px dotted transparent;
        }
      }
    }
  }
  .ant_more-win_mwn {
    .el-dialog {
      max-width: 1200px;
      .el-dialog__body {
        padding-top: 0;
        font-weight: 400;
        color: #333;
      }
      .ant_item {
        margin: 15px 0 0;
      }
      .ant_review-title {
        font-weight: 600;
        text-align: center;
        margin-bottom: 10px;
        font-size: 18px;
      }
      .ant_item-row {
        .ant_item-title {
          color: #333;
        }
        .ant_item-value {
          font-weight: 600;
          a {
            font-size: 15px;
            color: lighten($color-2, 10%);
            border-bottom: 1px dotted lighten($color-2, 10%);
            cursor: pointer;
            @include transition;
            line-height: 13px;
            display: inline-block;
            &:hover {
              color: $color-1;
              border-bottom: 1px dotted transparent;
            }
          }
        }
        table {
          border-collapse: collapse;
          margin: 5px 0 10px;
          tr {
            &:nth-of-type(1) {
              font-weight: bold;
              text-align: center;
            }
            &:nth-of-type(2n+1) {
              background: #fafafa;
            }
          }
          td {
            border: 1px solid #ddd;
            padding: 5px 7px;
            font-size: 14px;
            line-height: 17px;
            min-width: 100px;
            a {
              color: $color-1;
              @include transition;
              &:hover {
                color: $color-2;
              }
            }
          }
        }
      }
    }
  }
  .ant_more-btn {
    width: 100%;
    display: block;
    margin: 10px auto;
    padding: 8px 0 4px;
    @media (max-width: 600px) {
      display: none;
    }
  }
  &.theme-w {
    background: transparent;
    @include box-shadow(0 1px 12px rgba(0, 0, 0, 0.15));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Antiplagiat.vue